import { IUserDataModel } from '../../typings/userData';
import { UserDataAiBrainToolsType } from '../../gql/api-ai-tools/graphql';

export const userDataModel = (
  userData: UserDataAiBrainToolsType
): IUserDataModel => ({
  userId: userData?.userId ? String(userData.userId) : '',
  isUserSubscribed: userData?.hasSubscription === true,
  freePremiumGenerationsAttemptsCount:
    userData?.freePremiumGenAvailableAttempts || 0,
  clientHash: userData?.clientHash || '',
  isInitialUserDataUpdated: true,
});
